import React from 'react'
import { useIntl } from 'react-intl'

import { useOfMinWidth } from 'hooks'
import { APP_BREAKPOINTS } from 'consts'
import { useGetCartDeliveryItemsQuery } from 'containers/Cart/rtkApi'
import messages from 'views/CartV2/messages'
import ProductRow from './ProductRow'
import DeliveryDate from './DeliveryDate'
import DeliveryDetails from './DeliveryDetails'
import MobileDeliveryDetails from './DeliveryDetails/Mobile'

const DeliveryBox = ({ delivery }) => {
  const { formatMessage } = useIntl()
  const isDesktop = useOfMinWidth(APP_BREAKPOINTS.DESKTOP_START)
  const { date, route, id } = delivery

  const { data: deliveryItems = {}, isLoading } = useGetCartDeliveryItemsQuery({
    id,
  })
  const { items = [] } = deliveryItems

  if (isLoading) return null

  return (
    <div
      data-test-id={`cart_delivery-box#${date}_${route.id}`}
      className="flex flex-col gap-7 lg:flex-row"
    >
      <div className="flex justify-between items-center lg:items-start">
        <DeliveryDate date={date} />
        {!isDesktop && <MobileDeliveryDetails delivery={delivery} />}
      </div>
      <div className="flex flex-col gap-6 w-full">
        {isDesktop && <DeliveryDetails delivery={delivery} />}
        <div className="flex flex-col bg-white rounded-[20px] shadow-[0px_10px_10px_-8px_#00000026]">
          <div className="p-6">
            <span className="text-[16px] leading-6 font-medium">
              {formatMessage(messages.delivery)}
            </span>
          </div>
          <div className="flex flex-col lg:gap-1 lg:px-1">
            {items.map(item => (
              <ProductRow
                key={`${item.id}-${item.positions[0].measurement.unit}`}
                item={item}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeliveryBox
